import {

    FaCar,

    FaTools,

    FaMoneyBillWave,

    FaGasPump,

    FaShieldAlt,

    FaBell,
    FaSms,

} from "react-icons/fa";

import styles from "./ProFeaturesCard.module.css";

const features = [

    {

        icon: <FaCar />,

        title: "ثبت انواع وسیله نقلیه",

    },

    {

        icon: <FaTools />,

        title: "ثبت سرویس‌ها",

    },

    {

        icon: <FaMoneyBillWave />,

        title: "ثبت هزینه‌ها",

    },

    // {

    //     icon: <FaGasPump />,

    //     title: "مدیریت سوخت",

    // },

    {

        icon: <FaSms />,

        title: "پیامک هشدار سررسید سرویس ها",

    },

    {

        icon: <FaBell />,

        title: "یادآوری سرویس",

    },

];

const ProFeaturesCard = () => {

    return (

        <section className={styles.card}>

            <h3>

                امکانات فعال

            </h3>

            <div className={styles.grid}>

                {

                    features.map(

                        feature => (

                            <div

                                key={feature.title}

                                className={styles.item}

                            >

                                <span

                                    className={styles.icon}

                                >

                                    {feature.icon}

                                </span>

                                <span>

                                    {feature.title}

                                </span>

                            </div>

                        )

                    )

                }

            </div>

        </section>

    );

};

export default ProFeaturesCard;